import React, { useState } from 'react';
import { Table as AntTable, Button, Modal, Typography, Image, Row, Col, Badge } from 'antd';
import { Descriptions, Divider } from 'antd';
import { SearchOutlined, EditOutlined, UnorderedListOutlined, RightOutlined, DownOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import dayjs from 'dayjs';
const { Title, Text } = Typography;
const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const expanHeaderStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#686868ff",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false, refetch }) => {
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'number',
      key: 'number',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // onCell: () => ({ style: { backgroundColor: '#4a4a4a' } }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Admin',
      dataIndex: 'finish_by_name',
      key: 'finish_by_name',
      align: 'center',
      width: 130,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text, record) => (
      //   <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
      //     {record.case3Display || '-'}
      //   </span>
      // ),
    },
    {
      title: 'All',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'เวลาทำงาน',
      dataIndex: 'worktime',
      key: 'worktime',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (seconds) => {
        if (!seconds && seconds !== 0) return '-';
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return <span style={{ color: '#333', fontWeight: 500 }}>{`${h}:${m}:${s}`}</span>;
      },
    },
    {
      title: 'เวลา Waiting',
      dataIndex: 'waitingTime',
      key: 'waitingTime',
      align: 'center',
      width: 110,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (seconds) => {
        if (!seconds && seconds !== 0) return '-';
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return <span style={{ color: '#333', fontWeight: 500 }}>{`${h}:${m}:${s}`}</span>;
      },
    },
    {
      title: 'Dep',
      // dataIndex: 'depTotal',
      // key: 'depTotal',
      align: 'center',
      width: 90,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
      children: [
        {
          title: 'Total',
          dataIndex: 'depTotal',
          key: 'depTotal',
          align: 'center',
          width: 90,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
        {
          title: 'Amount',
          dataIndex: 'depAmount',
          key: 'depAmount',
          align: 'center',
          width: 120,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
      ],
    },

    {
      title: 'Withdraw',
      // dataIndex: 'witTotal',
      // key: 'witTotal',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
      children: [
        {
          title: 'Total',
          dataIndex: 'witTotal',
          key: 'witTotal',
          align: 'center',
          width: 90,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
        {
          title: 'Amount',
          dataIndex: 'witAmount',
          key: 'witAmount',
          align: 'center',
          width: 120,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
      ],
    },
    {
      title: 'ETC.',
      onHeaderCell: () => ({ style: headerStyle }),
      children: [
        {
          title: 'Total',
          dataIndex: 'etcTotal',
          key: 'etcTotal',
          align: 'center',
          width: 90,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
        {
          title: 'Amount',
          dataIndex: 'etcAmount',
          key: 'etcAmount',
          align: 'center',
          width: 120,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
      ],
    },
    {
      title: 'Panel',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      children: [
        {
          title: 'Total',
          dataIndex: 'panelTotal',
          key: 'panelTotal',
          align: 'center',
          width: 90,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
        {
          title: 'Amount',
          dataIndex: 'panelAmount',
          key: 'panelAmount',
          align: 'center',
          width: 120,
          onHeaderCell: () => ({ style: headerStyle }),
          render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
        },
      ],
    },
  ];

  const expandedRowRender = (record) => {
    return (
      <AntTable
        columns={expandColumns}
        dataSource={record.data}
        pagination={false}
        rowKey={(row, index) => index}
        size="small"
        bordered
      />
    );
  };

  const expandColumns = [
    { title: 'case1', dataIndex: 'caseName', key: 'caseName', align: 'center', onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'case2', dataIndex: 'case1_name', key: 'case1_name', align: 'center', onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'case3', dataIndex: 'case2_name', key: 'case2_name', align: 'center', onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'เติม-ไม่เติม', key: 'topUp', align: 'center', render: (record) => <span style={{ color: '#333' }}>{record.radioChoice == '1' ? <CheckCircleFilled style={{ color: 'green' }} /> : <CloseCircleFilled style={{ color: 'red' }} />}</span>, onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'ยอดเงิน', dataIndex: 'amount', key: 'amount', align: 'center', render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>, onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'Total', dataIndex: 'count', key: 'count', align: 'center', onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },
    { title: 'AVG Time (M.S)', dataIndex: 'avgTimeFormatted', key: 'avgTimeFormatted', align: 'center', onHeaderCell: () => ({ style: expanHeaderStyle }), width: 100 },

  ];

  return (
    // <div style={{ padding: '20px', background: '#fff' }}>
    <div className='overflow-x-auto'>
      <AntTable
        loading={loading}
        dataSource={genNumberTable(data)}
        columns={columns}
        expandable={{
          expandedRowRender,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <DownOutlined
                onClick={(e) => onExpand(record, e)}
                style={{ fontSize: 20 }}
              />
            ) : (
              <RightOutlined
                onClick={(e) => onExpand(record, e)}
                style={{ fontSize: 20 }}
              />
            ),
        }}
        //pagination={{ pageSize: 10 }}
        rowKey="finish_by"
        scroll={{ x: 'max-content' }}
        bordered
        pagination={{
          position: ['topRight'],     // 👈 เลือกตำแหน่งได้
          //pageSize: 20,
        }}
        pageSize={10}
        pageSizeOptions={[10, 20, 50, 100]}
        showSizeChanger={true}
        showQuickJumper={true}
      //showTotal={(total, range) => `รวม ${total} รายการ`}
      // onChange={(page, pageSize) => {
      //   console.log(page, pageSize);
      // }}
      />
      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
        .ant-table-thead > tr > th.ant-table-row-expand-icon-cell {
          background-color: #4a4a4a !important;
          color: white !important;
        }
      `}</style>
    </div>
    // </div>
  );
};

export default Table;

